<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="dialogVisible"
        center
        class="detail-dialog-container"
        width="555px">
        <div class="dialog-container flex flex-direction ">
            <img class="watermark" src="../assets/img/dialog_bg_2.png">
            <div class="dialog-operate flex align-center justify-end">
                <i class="close el-icon-close margin-left-xs" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction">
                <div class="title self-center margin-tb">{{state|state}}</div>
                <el-progress :percentage="percentage" :class="{loading:state === 0}"  :stroke-width="21"></el-progress>
                <div class="tips-container">
                    <div class="success flex align-center">
                        <template  v-if="state === 0">
                            <i class="el-icon-loading"></i>
                            <div class="info margin-left-xs">正在导入</div>
                        </template>
                        <template v-else>
                            <i class="text-green el-icon-check"></i>
                            <div class="info margin-left-xs">已成功导入{{ info.success }}条数</div>
                        </template>

                    </div>
                    <div class="error flex margin-top-sm" v-if="state === 1 && info.err_url">
                        <i class="text-red el-icon-close"></i>
                        <div class="flex flex-direction margin-left-xs">
                            <div class="info">{{ info.error }}条数据有问题，修改后进行上传</div>
                            <a class="link" target="_blank" :href="IMAGE_PATH + info.err_url" download="模版导入错误数据.xlsx">下载问题数据</a>
                        </div>
                    </div>
                </div>
                <div class="operate-container flex align-center justify-center margin-tb">
                    <div class="operate" @click="cancel">确定</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>

import {
    importPersonalUser_optimized,
    importUpdatePersonalUser_optimized,
    importUpdateUser_optimized,
    importUser_optimized
} from "@/api/organiz";
import {
    importPersonalUserFH_optimized,
    importUpdatePersonalUserFH_optimized,
    importUpdateUserFH_optimized,
    importUserFH_optimized
} from "@/api/branch";
import {IMAGE_PATH} from "@/config";

export default {
    components: {},
    name: "ImportStateDialog",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: {
            // 会员类型
            // 1 个人添加 11 个人更新 12 分支机构个人添加 13 分支机构个人更新
            // 2 单位添加 21 单位更新 22 分支机构单位添加 23 分支机构单位更新
            type: [Number, String],
            default: 1
        },
        filePath:{ // 文件地址
            type: [String],
            default: ''
        },
        step :{ // 总共需要几次
            type: [Number, String],
            default: 1
        },
    },
    data() {
        return {
            IMAGE_PATH:IMAGE_PATH,
            state:0,
            page:1,
            limit:50,
            info:''
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        percentage() {
            return (this.page === 1 ? 0 :  (this.page - 1) * 100 / this.step).toFixed(0)
        }
    },
    created() {

    },
    methods: {
        async init() {
            let _data = await this.getState()
            if (_data.status === 200) {
                this.state = _data.data.error === 0 ? 2 : 1
                this.page ++
                this.info = _data.data
                this.$emit('watchState', true)
            } else if (_data.status === 201) {
                this.state = 0
                this.page++
                if (this.dialogVisible) this.init();
            } else {
                this.state = -1
                this.page = 1
            }
        },
        getState() {
            switch(this.type){
                //个人会员
                case 1: return importPersonalUser_optimized(2,this.filePath,this.page,this.limit)
                case 11: return importUpdatePersonalUser_optimized(2,this.filePath,this.page,this.limit)
                case 12: return importPersonalUserFH_optimized(2,this.filePath,this.page,this.limit)
                case 13: return importUpdatePersonalUserFH_optimized(2,this.filePath,this.page,this.limit)
                //单位会员
                case 2: return importUser_optimized(2,this.filePath,this.page,this.limit)
                case 21: return importUpdateUser_optimized(2,this.filePath,this.page,this.limit)
                case 22: return importUserFH_optimized(2,this.filePath,this.page,this.limit)
                case 23: return importUpdateUserFH_optimized(2,this.filePath,this.page,this.limit)
            }
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    filters:{
        state(val) {
            switch (val) {
                case -1:return '导出出错，请重新上传'
                case 0:return '模板导入中，请勿操作页面，耐心等待'
                case 1:return '模板导入完成，请下载错误文件修改后再次导入'
                case 2:return '模板导入完成'
                default:return '模板导入中，请勿操作页面，耐心等待'

            }
        }
    },
    watch: {
        dialogVisible() {
            if (this.dialogVisible) {
                this.state = 0
                this.page = 1
                this.init()
            }
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/{
    .el-progress {
        display: flex;
    }
    .loading{
        .el-progress-bar__inner {
            animation: progressStripeLTR .6s linear infinite;
        }
    }
    .el-progress-bar__inner {
        background-color: #0056c1;
        background-image: linear-gradient(-45deg,#0a2240 25%,transparent 25%,transparent 50%,#0a2240 50%,#0a2240 75%,transparent 75%,transparent);
        background-repeat: repeat-x;
        background-size: 50px 50px;

        @keyframes progressStripeLTR {
            to {
                background-position: 50px 0
            }
        }
        &:before{
            display: block;
            content: '';
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            background-image: linear-gradient(90deg,
                #0056c199 0%,
                #0a224033 100%),
            linear-gradient(
                    #0a224088,
                    #0a224088);
            border-radius: 20px;
            background-blend-mode: normal,
            normal;
        }
    }
    .el-progress__text {
        width: 70px;
    }
}
.detail-dialog-container {
    .dialog-container {
        position: relative;
        background-image: linear-gradient(0deg,#ffffff 1%,  #bcdaff 100%),
        linear-gradient( #ffffff, #ffffff);
        background-blend-mode: normal, normal;
        padding: 13px 20px;
        border-radius: 10px;
        .watermark {
            width: 100%;
            right: 0;
            top: 0;
            position: absolute;
        }
        .close {
            font-size: 16px;
            color: #0a2240;
            cursor: pointer;
            z-index: 2;
        }
        .dialog-content {
            z-index: 1;
            padding: 0 70px;
            .title {
                font-size: 20px;
                font-weight: 600;
                color: #333333;
                span{
                    color: #ff7800;
                }
            }
            .tips-container {
                background-image: linear-gradient(0deg,#ffffff66 0%,  #ffffff 50%),
                linear-gradient( #ffffff00, #ffffff00);
                background-blend-mode: normal, normal;
                border-radius: 10px;
                padding: 16px 18px;
                min-height: 113px;
                margin-top: 13px;
                .info {
                    font-size: 14px;
                    color: #666666;
                }
                .link {
                    font-size: 14px;
                    color: #08499a;
                    text-decoration: underline;
                }

            }
            .operate-container {
                .operate+.operate {
                    margin-left: 46px;
                }
                .operate {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background-color: #0a2240;
                    border-radius: 20px;
                    cursor: pointer;
                    font-size: 14px;
                    color: #ffffff;
                    &.yellow {
                        background-color: #ff9600;
                    }
                }
            }
        }

    }
}
</style>
